// UI STATES
const CLEAR = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CLEAR'
const CHANGE_CURRENT_PAGE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CHANGE_CURRENT_PAGE'
const CHANGE_PAGE_SIZE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CHANGE_PAGE_SIZE'
const CHANGE_SEARCH_VALUE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CHANGE_SEARCH_VALUE'
const UPDATE_SEARCH_VALUE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_SEARCH_VALUE'
const UPDATE_PAGE_SIZE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_PAGE_SIZE'
const UPDATE_COUNT_SIZE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_COUNT_SIZE'
const UPDATE_CURRENT_PAGE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_CURRENT_PAGE'
const UPDATE_EDIT = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_EDIT'
const CHANGE_EDIT = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CHANGE_EDIT'
const APPROVAL_CARD = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard'
const UPDATE_PROJECTS_LIST = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_PROJECTS_LIST'
const CLEAR_PROJECTS_LIST = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CLEAR_PROJECTS_LIST'
const UPDATE_SELECT_SITE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/UPDATE_SELECT_SITE'
const CHANGE_SELECT_SITE = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/CHANGE_SELECT_SITE'

const FETCH_PROJECTS = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/FETCH_PROJECTS'
const FETCH_PROJECTS_START = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/FETCH_PROJECTS_START'
const FETCH_PROJECTS_SUCCESS = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/FETCH_PROJECTS_SUCCESS'
const FETCH_PROJECTS_ERROR = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/FETCH_PROJECTS_ERROR'

const PATCH_PROJECTS = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/PATCH_PROJECTS'
const PATCH_PROJECTS_START = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/PATCH_PROJECTS_START'
const PATCH_PROJECTS_SUCCESS = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/PATCH_PROJECTS_SUCCESS'
const PATCH_PROJECTS_ERROR = 'fulcrum/container/Manage/NvqualSubmissions/ApprovalCard/PATCH_PROJECTS_ERROR'

const ROW_OPTIONS = Object.freeze({
  10: 10,
  25: 25,
  50: 50
})

export {
  CLEAR,
  ROW_OPTIONS,
  CHANGE_PAGE_SIZE,
  CHANGE_CURRENT_PAGE,
  CHANGE_SEARCH_VALUE,
  FETCH_PROJECTS,
  FETCH_PROJECTS_START,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_ERROR,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_SEARCH_VALUE,
  CHANGE_EDIT,
  UPDATE_EDIT,
  APPROVAL_CARD,
  PATCH_PROJECTS,
  PATCH_PROJECTS_START,
  PATCH_PROJECTS_SUCCESS,
  PATCH_PROJECTS_ERROR,
  UPDATE_PROJECTS_LIST,
  CLEAR_PROJECTS_LIST,
  UPDATE_SELECT_SITE,
  CHANGE_SELECT_SITE
}
